import React, { useState, useEffect } from "react";
import { Button, Card, Container, Row, Col, Spinner, Alert } from "react-bootstrap";
import EditDonModal from "./EditModal";
import RepairService from "../../services/RepairService";
import "./style.css";

const DonBaoduongSuachuaMoi = () => {
    const [DonData, setDonData] = useState([
        {
            id: 'SA0123',
            bien_kiem_soat: "51A-12345",
            ngay_sua_chua: "2024-02-28T08:00:00Z",
            loai: "Bảo dưỡng định kỳ",
            ghi_chu: "Sửa cẩn thận",
            tram: "Trạm bảo dưỡng Quận 1",
            trang_thai: "Đã đến trạm",
            gia: 0,
            loai_xe: "Xe tải",
            tai_xe: "Lê Văn Khang(09121312)",
            phu_phi: [],
        },
        {
            id: 'BA0123',
            bien_kiem_soat: "51B-67890",
            ngay_sua_chua: "2024-02-27T14:30:00Z",
            loai: "Sửa chữa động cơ",
            tram: "Trạm bảo dưỡng Quận 7",
            tai_xe: "Lê Văn Nhật(09121312)",
            ghi_chu: "Thay cả động cơ nếu cần",
            loai_xe: "Xe khách",
            trang_thai: "Đã nhận nhiệm vụ",
            gia: 0,
            phu_phi: [],
        }
    ]);

    const [loading, setLoading] = useState(false); // Set true later if needed
    const [errorMessage, setErrorMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedDon, setSelectedDon] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await RepairService.BaoduongSuachuaMoi();
                const updatedData = response.data.map(item => ({
                    ...item,
                    phu_phi: item.phu_phi || [],
                }));
    
                setDonData(updatedData);
            } catch (error) {
                setErrorMessage("Lỗi khi tải dữ liệu! Vui lòng thử lại.");
                console.error("Fetch error:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleEdit = (don) => {
        setSelectedDon(don);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedDon(null);
    };

    const handleSave = async () => {
        if (!selectedDon.gia || selectedDon.gia <= 0) {
            alert("Giá không được để trống và phải lớn hơn 0.");
            return;
        }
    
        if (selectedDon.phu_phi.length > 0) {
            const hasInvalidPhuPhi = selectedDon.phu_phi.some(item => !item.ten.trim() || item.gia <= 0);
    
            if (hasInvalidPhuPhi) {
                alert("Mỗi phụ phí phải có tên và giá hợp lệ (giá phải lớn hơn 0).");
                return;
            }
        }
    
        setDonData((prevData) =>
            prevData.map((don) =>
                don.id === selectedDon.id ? selectedDon : don
            )
        );
        
        try {
            // Call API to save báo giá
            await RepairService.Bao_Gia({
                id: selectedDon.id,
                gia: selectedDon.gia,
                phu_phi: selectedDon.phu_phi,
            });
    
            alert("Báo giá đã được gửi thành công!");
    
            // Remove selectedDon from the list after saving
            setDonData(prevData => prevData.filter(don => don.id !== selectedDon.id));
            
            setShowModal(false);
            setSelectedDon(null);
        } catch (error) {
            console.error("Lỗi khi gửi báo giá:", error);
            alert("Lỗi khi gửi báo giá! Vui lòng thử lại.");
        }
    };
    
    

    const handleAddPhuPhi = () => {
        setSelectedDon((prev) => ({
            ...prev,
            phu_phi: [...prev.phu_phi, { ten: "", gia: 0 }],
        }));
    };

    const handleDeletePhuPhi = (index) => {
        setSelectedDon((prev) => {
            const newPhuPhi = [...prev.phu_phi];
            newPhuPhi.splice(index, 1);
            return { ...prev, phu_phi: newPhuPhi };
        });
    };
    

    const handlePhuPhiChange = (index, field, value) => {
        setSelectedDon((prev) => {
            const newPhuPhi = [...prev.phu_phi];
            newPhuPhi[index] = { ...newPhuPhi[index], [field]: value };
            return { ...prev, phu_phi: newPhuPhi };
        });
    };

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
                <p>Đang tải dữ liệu...</p>
            </Container>
        );
    }

    return (
        <Container fluid className="mt-4 ChuyenBaoduongSuachuaComponent">
            <h2>Danh sách đơn Bảo dưỡng - Sửa chữa mới</h2>

            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

            <Row xs={1} sm={2} md={3} lg={3} xl={3} className="g-4">
                {DonData.map((don) => (
                    <Col key={don.id} className="mb-4">
                        <Card>
                            <Card.Body style={{ textAlign: "center" }}>
                                <Card.Title className="text-center fw-bold">
                                    Mã Chuyến: {don.id}
                                </Card.Title>
                                <Card.Text>Biển kiểm soát: {don.bien_kiem_soat}</Card.Text>
                                <Card.Text>Ngày sửa chữa: {new Date(don.ngay_sua_chua).toLocaleDateString()}</Card.Text>
                                <Card.Text>Loại: {don.loai}</Card.Text>
                                <Card.Text>Loại xe: {don.loai_xe}</Card.Text>
                                <Button variant="primary" onClick={() => handleEdit(don)}>Báo giá</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            {selectedDon && (
                <EditDonModal
                    show={showModal}
                    handleClose={handleCloseModal}
                    selectedDon={selectedDon}
                    setSelectedDon={setSelectedDon}
                    handleAddPhuPhi={handleAddPhuPhi}
                    handleDeletePhuPhi={handleDeletePhuPhi}
                    handlePhuPhiChange={handlePhuPhiChange}
                    handleSave={handleSave}
                />
            )}
        </Container>
    );
};

export default DonBaoduongSuachuaMoi;
